/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlTestForm = "/test-forms";
const urlDeleteMultiple = "/test-forms/batch-delete";

const state = {
  test_forms: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * Get list test forms
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLists({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlTestForm}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_TEST_FORMS", response.data.data);
        return response.data.data;
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlTestForm, payload);
  },

  /**
   * Update
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlTestForm}/${id}`, payload);
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlTestForm}/${id}`);
  },

  /**
   * delete multiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  appendToList({ commit }, data) {
    commit("APPEND_TO_LIST", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  createSuccess({ commit }, data) {
    commit("CREATE_SUCCESS", data);
  },
};

const mutations = {
  SET_LIST_TEST_FORMS(state, data) {
    state.test_forms = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  APPEND_TO_LIST(state, data) {
    const pos = state.test_forms
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.test_forms.splice(pos, 1, data);
  },
  CREATE_SUCCESS(state, data) {
    state.test_forms.unshift(data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
